export class BpPageContext {
  path: string;
  url: string;
  constructor() {
    const queryParamTest = /\?.*/;
    const fullUrl = location.toString().replace(queryParamTest, '');

    this.path = location.pathname;
    this.url = fullUrl;
  }
}
